export default __webpack_public_path__ + "images/UI.280d82c.png";